module.exports = __webpack_public_path__ + "img/dataflow-03.6c870c6f.svg";